<template>
  <div class="rnr-card">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Card'
}
</script>

<style lang="scss" scoped>
.rnr-card {
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  box-sizing: border-box;
  margin: 0 24px 24px;
  padding: 0px 32px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Card.vue